import React, { Dispatch, FC, useEffect, useState } from 'react';
import moment from 'moment';
import classes from './employeeInfo.module.scss';

import { ReactComponent as Edith } from '../../assets/images/EdithUser.svg';
import { ReactComponent as Clock } from '../../assets/images/userClock.svg';
import { ReactComponent as Pen } from '../../assets/images/userPen.svg';
import { ReactComponent as Eye } from '../../assets/images/userEye.svg';
import { ReactComponent as Gift } from '../../assets/images/gift.svg';
import { ReactComponent as EyeOpen } from '../../assets/images/eye.svg';
import { ReactComponent as DownlandComments } from '../../assets/images/downlandComments.svg';
import { ReactComponent as Key } from '../../assets/images/key.svg';
import { ReactComponent as UnlockUser } from '../../assets/images/unlock-user.svg';
import { ReactComponent as LockUser } from '../../assets/images/lock-user.svg';

import photo from '../../assets/images/Avatar.png';
import { Staff } from '../../types/subdivision';
import { useAnalytics, useStaff, useStatus } from '../../hooks/entityHooks';
import { TypeModalWindow } from '../../types/utils/constants';

type nameBlockProps = {
  name: string;
  position: string;
  sex: boolean;
  birth: Date;
};
type infoBlockProps = {
  mPhone: string;
  cPhone: string;
  inPhone: string;
  email: string;
  upn: string;
};
type kadrBlockProps = {
  numb: string;
  org: string;
  leader: string;
  entryDate: Date;
  recieptDate: Date;
};
type dataBlockProps = {
  login: string;
};

type actionProps = {
  setLogs: Dispatch<boolean>;
  setConfig: Dispatch<Config>;
  open: boolean;
  setOpen: Dispatch<boolean>;
  info: Staff;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  handleGetTree(): void;
};

const LockStatus: FC<{ status: number; id: number }> = ({ status, id }) => {
  const [currentStatus, setCurrentStatus] = useState<number>(status);
  const { changeStatusStaff } = useStatus();

  switch (currentStatus) {
    case 1:
      return (
        <UnlockUser
          onClick={() => {
            changeStatusStaff(id, currentStatus).then(() => {
              setCurrentStatus(2);
            });
          }}
        />
      );
    case 2:
      return (
        <LockUser
          onClick={() => {
            changeStatusStaff(id, currentStatus).then(() => {
              setCurrentStatus(1);
            });
          }}
        />
      );
    default:
      return null;
  }
};

const createActions: FC<actionProps> = ({
  setLogs,
  setOpen,
  info,
  handleChangeIsKarmaUser,
  handleGetTree,
  setConfig,
}) => {
  return (
    <div className={classes.container__actions}>
      <span
        className={`${classes.tooltip} ${classes.lockIcon}`}
        data-tooltip="Видимость для поиска"
      >
        <LockStatus status={info.status} id={info.id} />
      </span>
      {/* <span
        className={`${classes.tooltip} ${classes.keyIcon}`}
        data-tooltip="Доступ в аналитику"
      >
        <Key
          onClick={() => {
            document.body.style.overflowY = 'hidden';
            setConfig({ state: true, type: TypeModalWindow.ACCESS_DIALOG });
          }}
        />
      </span>
      <span
        className={`${classes.tooltip} ${classes.thanksIcon}`}
        data-tooltip="Сервис Спасибо"
      >
        <DownlandComments
          onClick={() => {
            setConfig({ state: true, type: TypeModalWindow.THANKS_DIALOG });
          }}
        />
      </span>
      <span
        className={`${classes.tooltip} ${classes.configIcon}`}
        data-tooltip="Конфигурация полей"
      >
        <Edith
          onClick={() => {
            setConfig({ state: true, type: TypeModalWindow.CONFIG_DIALOG });
          }}
        />
      </span> */}
      <span
        className={`${classes.tooltip} ${classes.activityIcon}`}
        data-tooltip="Активность пользователя"
      >
        {info.isKarmaUser ? (
          <EyeOpen
            onClick={() => {
              handleChangeIsKarmaUser(
                info.id,
                TypeModalWindow.CONFIG_DIALOG,
                !info.isKarmaUser,
                handleGetTree,
              );
            }}
          />
        ) : (
          <Eye
            onClick={() => {
              handleChangeIsKarmaUser(
                info.id,
                TypeModalWindow.CONFIG_DIALOG,
                !info.isKarmaUser,
                handleGetTree,
              );
            }}
          />
        )}
      </span>
      {/* <span
        className={`${classes.tooltip} ${classes.penIcon}`}
        data-tooltip="Редактирование"
      >
        <Pen onClick={() => setOpen(true)} />
      </span>
      <span
        className={`${classes.tooltip} ${classes.historyIcon}`}
        data-tooltip="История действий"
      >
        <Clock onClick={() => setLogs(true)} />
      </span> */}
    </div>
  );
};

const createNameBlock = ({ name, position, sex, birth }: nameBlockProps) => {
  const DOB = moment(birth);
  return (
    <div className={classes.container__nameBlock}>
      <img src={photo} alt="" />
      <div className={classes.container__nameBlock__column}>
        <p className={classes.container__nameBlock__column__name}>{name}</p>
        <p className={classes.container__nameBlock__column__position}>
          {position}
        </p>

        <div className={classes.container__nameBlock__column__info}>
          <div className={classes.container__nameBlock__column__info__sex}>
            {sex ? 'Женский' : 'Мужской'}
          </div>
          <Gift />
          <p>{DOB.format('DD.MM.YYYY')}</p>
        </div>
      </div>
    </div>
  );
};

const createInfoBlock = ({
  cPhone,
  email,
  inPhone,
  mPhone,
  upn,
}: infoBlockProps) => {
  return (
    <div className={classes.container__infoBlock}>
      <div className={classes.container__infoBlock__title}>
        Информация для связи
      </div>
      <div className={classes.container__infoBlock__row}>
        <div className={classes.container__infoBlock__row__column}>
          <p className={classes.container__infoBlock__row__column__title}>
            Мобильный телефон
          </p>
          <p className={classes.container__infoBlock__row__column__target}>
            {mPhone}
          </p>
        </div>
        <div className={classes.container__infoBlock__row__column}>
          <p className={classes.container__infoBlock__row__column__title}>
            Гор. телефон
          </p>
          <p className={classes.container__infoBlock__row__column__target}>
            {cPhone}
          </p>
        </div>
        <div className={classes.container__infoBlock__row__column}>
          <p className={classes.container__infoBlock__row__column__title}>
            Вн. телефон
          </p>
          <p className={classes.container__infoBlock__row__column__target}>
            {inPhone}
          </p>
        </div>
      </div>
      <div className={classes.container__infoBlock__row}>
        <div className={classes.container__infoBlock__row__emailColumn}>
          <p className={classes.container__infoBlock__row__emailColumn__title}>
            Email
          </p>
          <p className={classes.container__infoBlock__row__column__target}>
            {email}
          </p>
        </div>
      </div>
      <div className={classes.container__infoBlock__row}>
        <div className={classes.container__infoBlock__row__emailColumn}>
          <p className={classes.container__infoBlock__row__emailColumn__title}>
            UPN
          </p>
          <p className={classes.container__infoBlock__row__column__target}>
            {upn}
          </p>
        </div>
      </div>
    </div>
  );
};

const createKadrBlock = ({
  entryDate,
  leader,
  numb,
  org,
  recieptDate,
}: kadrBlockProps) => {
  const entr = moment(entryDate);
  const reciept = moment(recieptDate);
  return (
    <div className={classes.container__kadrBlock}>
      <div className={classes.container__kadrBlock__title}>
        Кадровая информация
      </div>
      <div className={classes.container__kadrBlock__row}>
        <div className={classes.container__kadrBlock__row__column}>
          <p className={classes.container__kadrBlock__row__column__title}>
            Табельный номер
          </p>
          <p
            className={classes.container__kadrBlock__row__numberColumn__target}
          >
            {numb}
          </p>
        </div>
        <div className={classes.container__kadrBlock__row__column}>
          <p className={classes.container__kadrBlock__row__column__title}>
            Организация
          </p>
          <p className={classes.container__kadrBlock__row__column__target}>
            {org}
          </p>
        </div>
      </div>

      <div className={classes.container__kadrBlock__row}>
        <div className={classes.container__kadrBlock__row__column}>
          <p className={classes.container__kadrBlock__row__column__title}>
            Руководитель
          </p>
          <p
            className={classes.container__kadrBlock__row__numberColumn__target}
          >
            {leader}
          </p>
        </div>
      </div>

      <div className={classes.container__kadrBlock__row}>
        <div className={classes.container__kadrBlock__row__column}>
          <p className={classes.container__kadrBlock__row__column__title}>
            Дата вступления в должность
          </p>
          <p
            className={classes.container__kadrBlock__row__numberColumn__target}
          >
            {entr.format('DD.MM.YYYY')}
          </p>
        </div>
        <div className={classes.container__kadrBlock__row__column}>
          <p className={classes.container__kadrBlock__row__column__title}>
            Дата приема на работу
          </p>
          <p className={classes.container__kadrBlock__row__column__target}>
            {reciept.format('DD.MM.YYYY')}
          </p>
        </div>
      </div>
    </div>
  );
};

const createDataBlock = ({ login }: dataBlockProps) => {
  return (
    <div className={classes.container__dataBlock}>
      <div className={classes.container__dataBlock__title}>Учетные данные</div>
      <div className={classes.container__dataBlock__column}>
        <p className={classes.container__dataBlock__column__title}>
          Логин сотрудника
        </p>
        <p className={classes.container__dataBlock__column__target}>{login}</p>
      </div>
    </div>
  );
};

const createAccessBlock = (accessList: IAccessList) => {
  return (
    <div className={classes.container__accessBlock}>
      <div className={classes.container__accessBlock__title}>
        Доступ к Аналитике
      </div>
      <div className={classes.container__accessBlock__column}>
        <p className={classes.container__accessBlock__column__title}>
          Список подразделений
        </p>
        <p className={classes.container__accessBlock__column__target}>
          <p style={{ marginBottom: 8, marginTop: 0 }}>
            У данного сотрудника имеется доступ ко следующим организациям и
            подразделениям:
          </p>
          {accessList.organizations.map((item) => {
            return (
              <p className={classes.nameRow}>
                <span className={classes.organization}>{item.name};</span>
              </p>
            );
          })}
          {accessList.subdivisions.map((subdivision) => {
            return (
              <p className={classes.nameRow}>
                <span className={classes.organization}>
                  {`${subdivision.organization.name}: `}
                </span>
                {`${subdivision.name};`}
              </p>
            );
          })}
        </p>
      </div>
    </div>
  );
};

type LogsInfo = {
  id?: number;
  type?: number;
  handleGetTree?(): void;
};
type Config = {
  state: boolean;
  type: number;
};

interface IOrganization {
  id: number;
  name: string;
}

interface ISubdivision {
  id: number;
  name: string;
  organization: IOrganization;
}

export interface IAccessList {
  organizations: IOrganization[];
  subdivisions: ISubdivision[];
}

type props = {
  setLogs: Dispatch<boolean>;
  setConfig: Dispatch<Config>;
  open: boolean;
  setOpen: Dispatch<boolean>;
  handleChangeIsKarmaUser(
    id: number,
    type: number,
    value: boolean,
    handleGetTree: () => void,
  ): void;
  logsInfo: LogsInfo;
  handleUpdateEntity(entityId: number, type: number): Promise<void>;

  // info: Staff | undefined;
};

export const EmloyeeInfo = ({
  setLogs,
  setOpen,
  open,
  logsInfo,
  handleChangeIsKarmaUser,
  setConfig,
  handleUpdateEntity,
}: props) => {
  const { getEntity: getStaff, entity: info } = useStaff();
  const { id, type, handleGetTree } = logsInfo;
  const { getAccessEmployee, accessList } = useAnalytics();
  const [pastId, setPastId] = useState<number>(-1);

  useEffect(() => {
    if (id && pastId !== id) {
      if (type === 3) {
        getStaff(id);
        getAccessEmployee(id);
        setPastId(id);
      }
    }
  }, [id, handleChangeIsKarmaUser]);

  let internal = '';
  let mobile = '';
  let city = '';

  if (info && info.phones && info.phones.find((el) => el.type === 'internal')) {
    // @ts-ignore
    internal = info.phones.find((el) => el.type === 'internal').tel;
  }
  if (info && info.phones && info.phones.find((el) => el.type === 'mobile')) {
    // @ts-ignore
    mobile = info.phones.find((el) => el.type === 'mobile').tel;
  }
  if (info && info.phones && info.phones.find((el) => el.type === 'city')) {
    // @ts-ignore
    city = info.phones.find((el) => el.type === 'city').tel;
  }
  return (
    <>
      {info ? (
        <div className={classes.container}>
          {createActions({
            setLogs,
            setOpen,
            open,
            info,
            handleChangeIsKarmaUser,
            setConfig,
            handleGetTree: handleGetTree || (() => {}),
          })}
          {createNameBlock({
            birth: info.DOB,
            sex: info.gender,
            position: info.jobTitle,
            name: `${info.lastname} ${info.firstname} ${info.middlename}`,
          })}
          {createInfoBlock({
            upn: info.UPN,
            email: info.email,
            inPhone: internal,
            cPhone: city,
            mPhone: mobile,
          })}
          {createKadrBlock({
            recieptDate: info.DateofAdmission,
            entryDate: info.DateOfJobTitle,
            leader: info.manager
              ? `${info.manager.lastname} ${info.manager.firstname} ${info.manager.middlename}`
              : '',
            org: info.org.orgName,
            numb: `${info.JOBnumber}`,
          })}
          {createDataBlock({ login: info.SamAccountName })}
          {accessList && createAccessBlock(accessList)}
        </div>
      ) : null}
    </>
  );
};
